export function decodeUndefined(): undefined {
	return undefined;
}
